import View from "./View";

const ContactUs = ({ project, onNext, onBack }) => {
  const next = () => onNext({});

  return <View onNext={next} onBack={onBack} />;
};

export default ContactUs;
